function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#94C11F",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M2 38.166L10 38.166 10.209 46.411",
  transform: "translate(-943 -489) translate(944.762 490.271) rotate(-86 6.105 42.289)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.965 59.83c25.605 13.807 51.863 12.889 69.479 4.952C99.539 53.926 116.552 38.332 126.482 18",
  transform: "translate(-943 -489) translate(944.762 490.271) rotate(18 66.224 44.265)"
}))));

var SvgArrowOverviewMd4 = function SvgArrowOverviewMd4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 92,
    viewBox: "0 0 136 92",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowOverviewMd4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowOverviewMd4.ac9079ce.svg";
export { ForwardRef as ReactComponent };